
<div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'"><mat-spinner style="margin:0 auto; margin-top: 15%;" ></mat-spinner></div>

<div class="row" >
  <div class="col-sm-12">
    <div class="customers">
      <div class="card">
          <div class="card-body">
              <div style="padding: 20px 50px;">
                <div class="row" >
                  <div class="col-sm-6">
                    <p class="titulo-card-rojo">Agenda Tutorías</p>
                  </div>
                  <div class="col-sm-6" style="text-align: right;">
                      <div style="display: inline-block;border-radius: 50%; width: 15px;height: 15px;background-color: #F5BB3F;margin: 0px 5px;"></div>
                      <p style="display: inline-block;">Agendada</p>
                      <div style="display: inline-block;border-radius: 50%; width: 15px;height: 15px;background-color: #00b09e;margin: 0px 5px;"></div>
                      <p style="display: inline-block;">Disponible</p>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row text-center">
                        <div class="col-md-4">
                            <div class="btn-group">
                                <div
                                  class="btn btn-primary"
                                  mwlCalendarPreviousView
                                  [view]="view"
                                  [(viewDate)]="viewDate"
                                  (viewDateChange)="closeOpenMonthViewDay()"
                                >
                                  Anterior
                                </div>
                                <div
                                  class="btn btn-outline-secondary"
                                  mwlCalendarToday
                                  [(viewDate)]="viewDate"
                                >
                                  Hoy
                                </div>
                                <div
                                  class="btn btn-primary"
                                  mwlCalendarNextView
                                  [view]="view"
                                  [(viewDate)]="viewDate"
                                  (viewDateChange)="closeOpenMonthViewDay()"
                                >
                                  Siguiente
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                          <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):locale:weekStartsOn }}</h3>
                        </div>
                        <div class="col-md-4">
                            <div class="btn-group">
                                <div
                                  class="btn btn-primary"
                                  (click)="setView(CalendarView.Month)"
                                  [class.active]="view === CalendarView.Month"
                                >
                                  Mes
                                </div>
                                <div
                                  class="btn btn-primary"
                                  (click)="setView(CalendarView.Week)"
                                  [class.active]="view === CalendarView.Week"
                                >
                                  Semana
                                </div>
                                <div
                                  class="btn btn-primary"
                                  (click)="setView(CalendarView.Day)"
                                  [class.active]="view === CalendarView.Day"
                                >
                                  Día
                                </div>
                            </div>
                        </div>
                  </div>
                    <br />
                    <div [ngSwitch]="view">
                      <mwl-calendar-month-view
                        *ngSwitchCase="CalendarView.Month"
                        [viewDate]="viewDate"
                        [events]="events"
                        [refresh]="refresh"
                        [locale]="locale"
                        [weekStartsOn]="weekStartsOn"
                        [activeDayIsOpen]="false"
                        (dayClicked)="changeDay($event.day.date)"
                        (eventClicked)="handleEvent('Clicked', $event.event)"
                        
                      >
                      </mwl-calendar-month-view>
                      <mwl-calendar-week-view
                        *ngSwitchCase="CalendarView.Week"
                        [viewDate]="viewDate"
                        [events]="events"
                        [refresh]="refresh"
                        [locale]="locale"
                        [dayStartHour]="8"
                        [dayEndHour]="16"
                        [weekStartsOn]="weekStartsOn"
                        (eventClicked)="handleEvent('Clicked', $event.event)"
                        (eventTimesChanged)="eventDropped($event)"
                      >
                      </mwl-calendar-week-view>
                      <mwl-calendar-day-view
                        *ngSwitchCase="CalendarView.Day"
                        [viewDate]="viewDate"
                        [events]="events"
                        [refresh]="refresh"
                        [locale]="locale"
                        [dayStartHour]="8"
                        [dayEndHour]="16"
                        (eventClicked)="handleEvent('Clicked', $event.event)"
                        (eventTimesChanged)="eventDropped($event)"
                      >
                      </mwl-calendar-day-view>
                    </div>
                    
    
                </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</div>


  <!-- Everything you see below is just for the demo, you don't need to include it in your app -->
      
                  <ng-template #modalContent let-close="close">
                    <div class="modal-header">
                      <h5 class="modal-title">Event action occurred</h5>
                      <button type="button" class="close" (click)="close()">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div>
                        Action:
                        <pre>{{ modalData?.action }}</pre>
                      </div>
                      <div>
                        Event:
                        <pre>{{ modalData?.event | json }}</pre>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-outline-secondary" (click)="close()">
                        OK
                      </button>
                    </div>
                  </ng-template>  

      